import { render, staticRenderFns } from "./SingleTraningEvent.vue?vue&type=template&id=555d44ee&scoped=true&"
import script from "./SingleTraningEvent.vue?vue&type=script&lang=js&"
export * from "./SingleTraningEvent.vue?vue&type=script&lang=js&"
import style0 from "./SingleTraningEvent.vue?vue&type=style&index=0&id=555d44ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d44ee",
  null
  
)

export default component.exports